import { createContext } from "react";

export interface ISurveyPreviewQuestionIndexState {
  index: string;
  setIndex: (index: string) => void;
}

export const SurveyPreviewQuestionIndexContext =
  createContext<ISurveyPreviewQuestionIndexState | null>(null);